import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const grammarLearningContentAsync = createAsyncThunk(
  "web/grammarLearningContent",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/grammarLearningContent?chapterId=${payload.chapterId}`,
      payload,
      toolkit
    );
  }
);

export const getUserIdiomsByIdAsync = createAsyncThunk(
  "web/getUserIdiomsById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getUserIdiomsById/${payload.id}`,
      payload,
      toolkit
    );
  }
);

export const getAllIdiomsUserAsync = createAsyncThunk(
  "admin/getAllIdiomsUser",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllIdiomsUser?page=${payload.page}&limit=${payload.limit}`,
      [],
      toolkit
    );
  }
);

export const getContentsByTopicIdAsync = createAsyncThunk(
  "web/getContentsByTopicId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getSyllabusContentByTopicId?topicId=${payload.topicId}`,
      payload,
      toolkit
    );
  }
);

export const getSyllabusContentByIdAsync = createAsyncThunk(
  "web/getSyllabusContentById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getSyllabusContentById/${payload}`,
      [],
      toolkit
    );
  }
);

export const chapterNotesAsync = createAsyncThunk(
  "web/chapterNotes",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/chapterNotes?chapterId=${payload?.chapterId}`,
      [],
      toolkit
    );
  }
);

export const getLearningContentByIdAsync = createAsyncThunk(
  "web/getLearningContentById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/getLearningContentById`,
      payload,
      toolkit
    );
  }
);

export const userViewIdiomsAsync = createAsyncThunk(
  "web/userViewIdioms",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/userViewIdioms`, payload, toolkit);
  }
);

export const addMarkAsReadAsync = createAsyncThunk(
  "web/addMarkAsRead",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addMarkAsRead`, payload, toolkit);
  }
);

//resumeLearning
export const resumeLearningAsync = createAsyncThunk(
  "user/resumeLearning",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/resumeLearning?subjectId=${payload.subjectId}&chapterId=${payload.chapterId}`,
      payload,
      toolkit
    );
  }
);

//voucherByUserId
export const voucherByUserIdAsync = createAsyncThunk(
  "user/voucherByUserId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/voucherByUserId?packageId=${payload?.packageId}&search=${payload?.searchVoucher}`,
      payload,
      toolkit
    );
  }
);

// addRecentActivity
export const addRecentActivityAsync = createAsyncThunk(
  "user/addRecentActivity",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addRecentActivity`, payload, toolkit);
  }
);

// display content
export const userChapterBySubjectIdAsync = createAsyncThunk(
  "user/userChapterBySubjectId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/userChapterBySubjectId`,
      payload,
      toolkit
    );
  }
);

export const learningCurriculumAsync = createAsyncThunk(
  "web/learningCurriculum",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/learningCurriculum?packageId=${payload?.packageId || ""}`,
      [],
      toolkit
    );
  }
);

export const myLearningContentAsync = createAsyncThunk(
  "web/myLearningContent",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/myLearningContent`, [], toolkit);
  }
);

export const coursePackagesByStudentAsync = createAsyncThunk(
  "web/coursePackagesByStudent",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/coursePackagesByStudent?type=${payload.type}`,
      [],
      toolkit
    );
  }
);

export const userAllBatchesAsync = createAsyncThunk(
  "user/allBatches",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/userAllBatches`, payload, toolkit);
  }
);

export const userCoursePackageBypackageIdAsync = createAsyncThunk(
  "web/userCoursePackageBypackageId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/userCoursePackageBypackageId?packageId=${payload?.packageId}`,
      [],
      toolkit
    );
  }
);

export const getEducatorsAsync = createAsyncThunk(
  "web/getEducators",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getEducators?packageId=${payload.packageId}`,
      [],
      toolkit
    );
  }
);
